import { useContext } from "react";
import { useSelector } from "react-redux";

import { BaseBenefitsList } from "../../../../components/BaseComponents/BaseBenefitsList";
import { BaseColumnInformation } from "../../../../components/BaseComponents/BaseColumnInformation";
import { BaseCompanyLogo } from "../../../../components/BaseComponents/BaseCompanyLogo";
import { BaseFeaturedCompanyHeader } from "../../../../components/BaseComponents/BaseFeaturedCompanyHeader";
import BaseLinkWrapper from "../../../../components/BaseComponents/BaseLinkWrapper";
import BaseReviewLink from "../../../../components/BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../../../components/BaseComponents/BaseServiceFlag";
import { BaseTrustpilotReview } from "../../../../components/BaseComponents/BaseTrustpilotReview";
import { BaseVisitLink } from "../../../../components/BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../../../components/CompanyList/CompanyContext";
import { getAwardText } from "../../../../selectors";
import { getStyles } from "./styles";
import { DEFAULT_LINK_TEXT, ThemeContext } from "./ThemeContext";

export const TCRColumnLayout = () => {
	const { company, companyIndex, isFeaturedCompany } =
		useContext(CompanyContext);
	const { linkText = DEFAULT_LINK_TEXT, hasTrustPilotWidget = true } =
		useContext(ThemeContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles({ companyIndex });

	return (
		<div
			className={`tw:relative ${isFeaturedCompany ? "tw:mt-8 tw:rounded-sm tw:[border:1.5px_solid_#4299e1]" : "tw:mt-4.5 tw:rounded-[3px] tw:[border-bottom:1px_solid_#f2f3f4]"}`}
		>
			<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />

			<div className={`tw:bg-white ${isFeaturedCompany ? "tw:px-2" : ""}`}>
				<div
					className={`tw:relative tw:mx-auto tw:flex tw:max-w-[500px] tw:flex-col tw:md:max-w-none tw:desktop:flex-row ${awardText ? "tw:pt-[1.85rem] tw:xs:pt-6 tw:desktop:pt-0" : ""}`}
				>
					<BaseServiceFlag classNames={styles.serviceFlag} />

					<div
						className={`tw:flex tw:px-[15px] tw:pt-[15px] tw:xs2:pt-[20px] tw:md:py-[20px] tw:md:pr-[20px] tw:md:pl-[40px] tw:desktop:w-[20%] tw:desktop:px-0 ${awardText ? "tw:desktop:py-12" : "tw:desktop:py-0"}`}
					>
						<BaseLinkWrapper
							className={`tw:flex tw:w-full tw:items-center ${hasTrustPilotWidget ? "tw:justify-between" : "tw:justify-center"} tw:desktop:flex-col tw:desktop:justify-center`}
						>
							<BaseCompanyLogo classNames={styles.companyLogo} />

							{hasTrustPilotWidget && (
								<BaseTrustpilotReview classNames={styles.trustpilotReview} />
							)}
						</BaseLinkWrapper>
					</div>

					<div className="tw:flex tw:flex-col tw:items-center tw:px-[15px] tw:py-5 tw:xs2:px-10 tw:md:pt-[10px] tw:desktop:w-[80%] tw:desktop:flex-row tw:desktop:justify-between tw:desktop:py-[15px] tw:desktop:pr-0 tw:desktop:pl-[15px] tw:lg2:p-6">
						<div className="tw:flex tw:w-full tw:flex-col tw:desktop:flex-row">
							<BaseLinkWrapper className="tw:flex tw:w-full tw:items-center tw:desktop:max-w-[305px] tw:lg2:max-w-[355px]">
								<BaseColumnInformation classNames={styles.columnInformation} />
							</BaseLinkWrapper>

							<BaseLinkWrapper>
								<BaseBenefitsList
									{...styles.benefitsList}
									isExpandable={true}
									mobileItemsToShow={2}
								/>
							</BaseLinkWrapper>
						</div>

						<div className="tw:mx-[15px] tw:mt-[15px] tw:flex tw:w-full tw:flex-col tw:items-center tw:xs2:flex-row-reverse tw:xs2:justify-evenly tw:md:mt-[10px] tw:desktop:mt-0 tw:desktop:w-fit tw:desktop:flex-col tw:desktop:items-center tw:desktop:justify-center tw:lg2:mr-0">
							<BaseLinkWrapper className="tw:relative tw:inline-flex tw:h-[46px] tw:w-[75%] tw:max-w-[210px] tw:items-center tw:justify-evenly tw:rounded-[3px] tw:bg-[#6ac54e] tw:font-montserrat tw:text-[14px] tw:leading-none tw:font-bold tw:text-white tw:before:h-[23px] tw:before:w-[23px] tw:before:bg-[url(/public/react-images/common/dollarImage.svg)] tw:before:bg-cover tw:before:bg-no-repeat tw:after:h-[10px] tw:after:w-[6px] tw:after:bg-[url(/public/react-images/common/forwardArrow.svg)] tw:after:bg-cover tw:after:bg-no-repeat tw:after:duration-[0.4s] tw:after:ease-in-out tw:hover:bg-[#14a929] tw:hover:after:translate-x-[5px] tw:xs2:w-[160px] tw:xs2:max-w-[initial] tw:lg2:w-[175px]">
								<BaseVisitLink>{linkText}</BaseVisitLink>
							</BaseLinkWrapper>

							<BaseReviewLink
								classNames={styles.reviewLink}
								linkText="Read Our Review"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
